"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BeefyWithdrawRecipe = void 0;
const recipe_1 = require("../../recipe");
const beefy_1 = require("../../../api/beefy");
const beefy_withdraw_step_1 = require("../../../steps/vault/beefy/beefy-withdraw-step");
const min_gas_limits_1 = require("../../../models/min-gas-limits");
class BeefyWithdrawRecipe extends recipe_1.Recipe {
    constructor(vaultID) {
        super();
        this.config = {
            name: 'Beefy Vault Withdraw',
            description: 'Withdraws ERC20 tokens from yield-bearing Beefy Vault.',
            minGasLimit: min_gas_limits_1.MIN_GAS_LIMIT_BEEFY_VAULT_WITHDRAW,
        };
        this.vaultID = vaultID;
    }
    supportsNetwork(networkName) {
        return beefy_1.BeefyAPI.supportsNetwork(networkName);
    }
    async getInternalSteps(firstInternalStepInput) {
        const { networkName } = firstInternalStepInput;
        const vault = await beefy_1.BeefyAPI.getBeefyVaultForID(this.vaultID, networkName);
        return [new beefy_withdraw_step_1.BeefyWithdrawStep(vault)];
    }
}
exports.BeefyWithdrawRecipe = BeefyWithdrawRecipe;
